import React, { Component } from 'react';
import { FormControl} from 'react-bootstrap';


class DebitNotes extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            value: props.submission && props.submission.onCreditNotes ? props.submission.onCreditNotes : ''
        };
    }

    handleChange(evt) {
        const val = evt.target.value;
        this.setState({
            ...this.state,
            value: val
        }, () => {this.props.onCreditNotes(this.state.value)})
    }

    render() { 
        
            return (<div className="creditNotesContainer">
            <h4 className="quoteTitle">Underwriter Notes (mandatory if Credit/Debit is applied)</h4>
            <FormControl
                autoComplete={false}
                type={'text'}
                onChange={this.handleChange}
                componentClass={'textarea'}
                value={this.state.value}
                defaultValue={this.state.value}
                placeholder={'Optional'}
            />
        </div>
            );
    }
}

export default DebitNotes;